module.exports = __webpack_public_path__ + "static/media/logo.a1cb5d0a.png";